module.exports = __webpack_public_path__ + "static/media/project.0bfa2d94.jpg";